import React from "react";
import { Skeleton, SkeletonProps } from "@mui/material";

const CustomSkeleton: React.FC<SkeletonProps> = (props) => {
  const { sx, ...rest } = props;

  return (
    <Skeleton
      animation="wave"
      sx={{
        ...sx,
      }}
      {...rest}
    />
  );
};

export default CustomSkeleton;
